import SelectButton from './select-button'
import Checkbox from './checkbox'
import CheckboxLabel from './checkbox-label'
import Date from './date'
import Label from './label'
import Labels from './labels'
import Maturity from './maturity-date'
import Number from './number'
import Price from './price'
import Quantity from './quantity'
import Radio from './radio'
import Rating from './ratings'
import { default as Search, SearchOption } from './search'
import SearchCusip from './search-cusip'
import Select from './select'
import SelectMulti from './select-multi'
import Text from './text'
import Yield from './yield'

export const Fields = {
    Checkbox,
    CheckboxLabel,
    Date,
    Label,
    Labels,
    Maturity,
    Number,
    Price,
    Quantity,
    Radio,
    Rating,
    SelectButton,
    Search,
    SearchOption,
    SearchCusip,
    Select,
    SelectMulti,
    Text,
    Yield,
}



// WEBPACK FOOTER //
// ./src/twd/fields/index.js